/**
 * 定数の設定
 * 各コンポーネントではmixinとして呼び込む
 * なお、同名の定数値がすでに存在した場合、そちらが優先されるので注意
 */
var constMixin = {
  data: function () {
    return {
      awardTypes: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16
      ],
      awardTypeNames: {
        1: '10選2020',
        2: '10選2019',
        3: '10選2018',
        4: '10選2017',
        5: '10選2016',
        6: '10選2015',
        7: '10選2014',
        8: '10選2013',
        9: '10選2012',
        10: '日本写真100景',
        11: 'Twitterポスター',
        12: 'Twitterスナップ',
        13: 'Twitterポートレート',
        14: 'Japan Travel Gallery Photo Contest 2021',
        15: 'Weibo',
        16: '協賛団体展示',
      },
      awardTypeCode: {
        1: 'Tcc10Sen2020',
        2: 'Tcc10Sen2019',
        3: 'Tcc10Sen2018',
        4: 'Tcc10Sen2017',
        5: 'Tcc10Sen2016',
        6: 'Tcc10Sen2015',
        7: 'Tcc10Sen2014',
        8: 'Tcc10Sen2013',
        9: 'Tcc10Sen2012',
        10: 'Japan100Views',
        11: 'TwitterPoster',
        12: 'TwitterSnap',
        13: 'TwitterPortrait',
        14: 'Jtg',
        15: 'Weibo',
        16: 'SpecialExhibitons',
        99: 'blank'
      },
      awardTypeSwipeCategory: {
        1: 'Tcc10Sen',
        2: 'Tcc10Sen',
        3: 'Tcc10Sen',
        4: 'Tcc10Sen',
        5: 'Tcc10Sen',
        6: 'Tcc10Sen',
        7: 'Tcc10Sen',
        8: 'Tcc10Sen',
        9: 'Tcc10Sen',
        10: 'Japan100Views',
        11: 'Twitter',
        12: 'Twitter',
        13: 'Twitter',
        14: 'Jtg',
        15: 'Weibo',
        16: 'SpecialExhibitons',
      },
      awardYears: {
        1: '2020',
        2: '2019',
        3: '2018',
        4: '2017',
        5: '2016',
        6: '2015',
        7: '2014',
        8: '2013',
        9: '2012',
      },
      awardTwitterCategory: {
        11: 'snap',
        12: 'poster',
        13: 'portrait'
      },
      areaAlphabetMap: {
        '北海道': 'hokkaido',
        '東北': 'tohoku',
        '関東': 'kanto',
        '中部': 'chubu',
        '近畿': 'kinki',
        '中国': 'chugoku',
        '四国': 'shikoku',
        '九州': 'kyushu',
        '沖縄': 'okinawa',
        '海外': 'overseas',
      },
      prefecturesMap: {
        '北海道': '北海道',
        '青森県': '東北',
        '岩手県': '東北',
        '宮城県': '東北',
        '秋田県': '東北',
        '山形県': '東北',
        '福島県': '東北',
        '茨城県': '関東',
        '栃木県': '関東',
        '群馬県': '関東',
        '埼玉県': '関東',
        '千葉県': '関東',
        '東京都': '関東',
        '神奈川県': '関東',
        '新潟県': '中部',
        '富山県': '中部',
        '石川県': '中部',
        '福井県': '中部',
        '山梨県': '中部',
        '長野県': '中部',
        '岐阜県': '中部',
        '静岡県': '中部',
        '愛知県': '中部',
        '三重県': '近畿',
        '滋賀県': '近畿',
        '京都府': '近畿',
        '大阪府': '近畿',
        '兵庫県': '近畿',
        '奈良県': '近畿',
        '和歌山県': '近畿',
        '鳥取県': '中国',
        '島根県': '中国',
        '岡山県': '中国',
        '広島県': '中国',
        '山口県': '中国',
        '徳島県': '四国',
        '香川県': '四国',
        '愛媛県': '四国',
        '高知県': '四国',
        '福岡県': '九州',
        '佐賀県': '九州',
        '長崎県': '九州',
        '熊本県': '九州',
        '大分県': '九州',
        '宮崎県': '九州',
        '鹿児島県': '九州',
        '沖縄県': '沖縄',
        'ミャンマー': '海外'
      },
      prefecturesAlphabetMap: {
        '北海道': 'hokkaido',
        '青森県': 'aomori',
        '岩手県': 'iwate',
        '宮城県': 'miyagi',
        '秋田県': 'akita',
        '山形県': 'yamagata',
        '福島県': 'fukushima',
        '茨城県': 'ibaraki',
        '栃木県': 'tochigi',
        '群馬県': 'gunma',
        '埼玉県': 'saitama',
        '千葉県': 'chiba',
        '東京都': 'tokyo',
        '神奈川県': 'kanagawa',
        '新潟県': 'niigata',
        '富山県': 'toyama',
        '石川県': 'ishikawa',
        '福井県': 'fukui',
        '山梨県': 'yamanashi',
        '長野県': 'nagano',
        '岐阜県': 'gifu',
        '静岡県': 'shizuoka',
        '愛知県': 'aichi',
        '三重県': 'mie',
        '滋賀県': 'shiga',
        '京都府': 'kyoto',
        '大阪府': 'osaka',
        '兵庫県': 'hyogo',
        '奈良県': 'nara',
        '和歌山県': 'wakayama',
        '鳥取県': 'tottori',
        '島根県': 'shimane',
        '岡山県': 'okayama',
        '広島県': 'hiroshima',
        '山口県': 'yamaguchi',
        '徳島県': 'tokushima',
        '香川県': 'kagawa',
        '愛媛県': 'ehime',
        '高知県': 'kochi',
        '福岡県': 'fukuoka',
        '佐賀県': 'saga',
        '長崎県': 'nagasaki',
        '熊本県': 'kumamoto',
        '大分県': 'oita',
        '宮崎県': 'miyazaki',
        '鹿児島県': 'kagoshima',
        '沖縄県': 'okinawa',
        'ミャンマー': 'myanmar'
      },
      commentAllowAwardTypes: [1, 2, 3, 4, 5, 6, 7, 8, 9 ,10],
      linkUrl100Kei: 'https://japanphotospot.tokyocameraclub.com/?id=',
      spacerAwardTypeId: 99,
      spacerPageInitialIndex: 9000000
    }
  }
}

export default constMixin
